var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-admin-user pad"},[_c('div',{staticClass:"pad"},[(_vm.user)?_c('admin-user-form',{attrs:{"user":_vm.user},on:{"submitted":_vm.submitted}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }